import { useEffect, useMemo } from 'react';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { PaddiqLogo } from '@kangaroo/ui';

function buildAppReturnUrl(search: string) {
  const incoming = new URLSearchParams(search);
  const outgoing = new URLSearchParams();
  const billing = incoming.get('billing');
  const sessionId = incoming.get('session_id');

  if (billing) {
    outgoing.set('billing', billing);
  }

  if (sessionId) {
    outgoing.set('session_id', sessionId);
  }

  const query = outgoing.toString();
  return `paddiq://billing/checkout${query ? `?${query}` : ''}`;
}

export function MobileBillingReturnPage() {
  const location = useLocation();
  const appReturnUrl = useMemo(() => buildAppReturnUrl(location.search), [location.search]);

  useEffect(() => {
    window.location.href = appReturnUrl;
  }, [appReturnUrl]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3 }}>
      <Paper sx={{ width: '100%', maxWidth: 420, p: 3 }}>
        <Stack spacing={2.5} alignItems="center">
          <PaddiqLogo />
          <Typography variant="h5" fontWeight={800}>Returning to Paddiq</Typography>
          <Alert severity="info">
            Your checkout is complete. If Paddiq does not reopen automatically, use the button below.
          </Alert>
          <Button variant="contained" href={appReturnUrl}>Open Paddiq</Button>
        </Stack>
      </Paper>
    </Box>
  );
}
